<template>
    <header class="bg-white vechile-detail">
            <div class="container custom-container">
                <nav class="navbar navbar-expand-lg navbar-light p-0">
                    <a class="navbar-brand p-0" @click="goHome" v-if="language === 'ar'" style="cursor: pointer">
                        <img src="@/assets/images/logo/color-en-logo.svg" class="img-fluid d-none d-lg-inline" width="280">
                        <img src="@/assets/images/logo/color-en-logo.svg" class="img-fluid d-lg-none" width="229">
                    </a>
                    <a class="navbar-brand p-0" @click="goHome" v-else style="cursor: pointer">
                        <img src="@/assets/images/logo/color-en-logo.svg" class="img-fluid d-none d-lg-inline" width="280">
                        <img src="@/assets/images/logo/color-en-logo.svg" class="img-fluid d-lg-none" width="229">
                    </a>
                    
                    <!-- where button header -->
                    <div class="wizard-navigation health-wizard d-flex flex-wrap justify-content-center d-none d-lg-flex d-xl-flex">
                        <h-no-quotes v-if="isMobile" />
                        <h-header-default v-else />
                    </div>

                    <div class="header-right d-flex flex-wrap align-items-center header-right-custom">
                        <div class="header-right__contact d-flex flex-wrap align-items-center">
                            <a :href="companyInfo.whatsapp_url" class="header-right__contact__item position-relative whats-app" target="_blank">
                                <div class="header-icon">
                                    <img src="@/assets/images/icons/new/whatsapp-header.svg" class="img-fluid">
                                </div>
                            </a>

                            <a :href="companyInfo.toll_free_number_tel" class="header-right__contact__item position-relative call-app">
                                <div class="header-icon">
                                    <img src="@/assets/images/icons/call-1.svg" class="img-fluid">
                                </div>
                                <div class="header-number" style="direction:ltr;">
                                    <p>{{ companyInfo.toll_free_number }}</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
</template>
<script>
import { computed, defineComponent, inject, ref } from 'vue';
import router from '@/router';
import { store } from '@/store';
import Language from '@/core/services/Language';

export default defineComponent({
    created() {
        const html = document.documentElement // returns the html tag
        html.setAttribute('lang', window.localStorage.getItem('language'))
        html.setAttribute('dir', window.localStorage.getItem('language') == 'en' ? 'ltr' : 'rtl')
    },
    
    setup() {
        const language = computed(() => {
            return store.state.lang.lang
        })

        const isMobile = inject('isMobile')
        const changeLanguage = (e) => {
            Language.setLanguage(e);
            window.location.reload();
        }

        const homePage = process.env.VUE_APP_PAYMENT_GATEWAY_URL + `/` + language.value;

        const omt = computed(() => router.currentRoute.value.query && router.currentRoute.value.query.channel ? router.currentRoute.value.query.channel : null)
        const hitMe = ref(false)
        async function goHome() {
            if(omt.value) {
                const cp = window.localStorage.getItem('cp')
                const pcp = window.localStorage.getItem('pcp')
                if(cp && pcp) {
                    if(!hitMe.value) {
                        hitMe.value = true
                        
                        const result = await store.dispatch('GO_HOME_OR_GO_BACK_AT_ONE', { 
                            product_type: 'travel',
                            phone_number: cp,
                            phone_country_code: pcp,
                        })
    
                        window.location.href = result.url
                    }
                }
            } else {
                window.location.href = homePage
            }
        }

        const customer = computed(() => {
            return store.state.personals.customer;
        });

        const companyInfo = computed(() => {
      return store.state.countries.company_info
    })

        return {
            goHome,
            customer,
            homePage,
            language,
            changeLanguage,
            companyInfo
        }
    }    
})

</script>